export const UPDATE_MANAGER_FORM = "UPDATE_MANAGER_FORM";
export const RESET_MANAGER_FORM = "RESET_MANAGER_FORM";

export const updateManagerForm = (formData) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_MANAGER_FORM,
      payload: formData,
    });
  };
};

export const resetManagerForm = () => {
  return (dispatch) => {
    dispatch({
      type: RESET_MANAGER_FORM,
    });
  };
};